const SUCCESS_CREATE_EMAIL_MESSAGE_TEXT = 'Berhasil membuat email baru';
const SUCCESS_EDIT_EMAIL_MESSAGE_TEXT = 'Berhasil mengubah email';
const SUCCESS_DELETE_EMAIL_MESSAGE_TEXT = 'Berhasil menghapus email';

export default {
  SUCCESS_CREATE_EMAIL_MESSAGE_TEXT,
  SUCCESS_EDIT_EMAIL_MESSAGE_TEXT,
  SUCCESS_DELETE_EMAIL_MESSAGE_TEXT,
};
